/* eslint-disable unicorn/prefer-top-level-await */

import { z } from 'zod'
import { catchWithSentryCapture } from '../utils'

export const ALERT_ORDER_BY_OPTIONS = [
  'created_at',
  'assignee',
  'status',
  'relevance',
] as const
export const alertOrderBySchema = z
  .enum(['created_at', 'assignee', 'status', 'relevance'])
  .optional()
  .default('created_at')
  .catch(catchWithSentryCapture('created_at' as const, 'alertOrderBySchema'))
export type AlertOrderBy = z.infer<typeof alertOrderBySchema>
